import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@material-ui/core';
import React from 'react';
import { Formik, Form } from 'formik';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

const SendSmsModal = ({ userId, phoneNumber, showModal, MODAL_TYPE }) => {
    const { notifyError, notifySuccess } = useNotify();

    return (
        <Dialog
            aria-labelledby="sms-modal"
            open
            maxWidth="sm"
            fullWidth
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogTitle>Send Text Message</DialogTitle>
            <Formik
                initialValues={{ message: '' }}
                onSubmit={({ message }, { setSubmitting }) => {
                    doSwaggerCall('users', 'sendCustomSms', {
                        userId,
                        smsData: {
                            message,
                            notification: ['sms']
                        }
                    })
                        .then(() => {
                            notifySuccess('SMS sent successfully');
                            showModal(MODAL_TYPE.NONE);
                        })
                        .catch(err => {
                            console.log(err);
                            notifyError('Could not send SMS');
                        })
                        .finally(() => {
                            setSubmitting(false);
                        });
                }}
            >
                {({ values, handleChange, isSubmitting }) => (
                    <Form>
                        <DialogContent>
                            <TextField
                                label="To"
                                value={phoneNumber || ''}
                                disabled
                                fullWidth
                                variant="outlined"
                                style={{ marginBottom: '16px' }}
                            />
                            <TextField
                                label="Message"
                                name="message"
                                value={values.message}
                                onChange={handleChange}
                                multiline
                                minRows={6}
                                fullWidth
                                variant="outlined"
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                                Close
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!values.message || isSubmitting}
                                type="submit"
                            >
                                Send SMS
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default SendSmsModal;
